export const animationDuration = '0.3s';
export const slideUpThreshold = 20;
export const closeThreshold = 0.3;
export const drawerBottomBuffer = {
  default: '50vh',
  sticky: '200px'
};